import FormFooter from 'components/organisms/Form/FormFooter/FormFooter'
import React, { Component } from 'react'
import { Col, Row } from 'react-bootstrap'
import { FaEdit, FaTrashAlt } from 'react-icons/fa'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import * as FormConst from '../../../../constants/FormConst'
import RouteConst from '../../../../constants/RouteConst'
import SessionConst from '../../../../constants/SessionConst'
import SideNavEntryMapping from '../../../../constants/SideNavEntryMapping'
import { asyncMethod } from '../../../../redux/actions'
import * as actionTypes from '../../../../redux/actionTypes'
import RoomTypesService from '../../../../services/RoomTypesService'
import {isArrayNotEmpty, isHotelDomestic, isRadissonProperty, isManageRoomTypeBucketsEnabled, isCompletedHotelInfoHistory} from '../../../../utilities/JSUtil'
import { getSessionItem } from '../../../../utilities/SessionHelper'
import Button from '../../../atoms/Button/Button'
import Card from '../../../molecules/Card/Card'
import FormModal from '../../../organisms/FormModal/FormModal'
import withFormLayout from '../WithFormLayout'
import './RoomTypes.scss'
import EnvVarsConst from "../../../../constants/EnvVarsConst";

class RoomTypes extends Component {

    headers = ['Code', 'Master Room Type Code', 'Description', 'Category', 'Max Occupancy', 'Room Count', 'Edit', 'Delete']

    constructor(props) {
        super(props)
        const hotelCode = getSessionItem(SessionConst.HOTEL_CODE)
        const hotelInfo = getSessionItem(SessionConst.HOTEL_INFO)
        const hotelInfoCompletedHistory = getSessionItem(SessionConst.HOTEL_INFO_COMPLETED_HISTORY);

        if (!hotelCode || !hotelInfo) {
            this.props.history.push(RouteConst.ROUTE_HOME_PAGE)
        }

        const isDomestic = isHotelDomestic(hotelInfo)

        this.addRoomType = this.addRoomType.bind(this)
        this.deleteRoomType = this.deleteRoomType.bind(this)
        this.handleDelete = this.handleDelete.bind(this)
        this.onEdit = this.onEdit.bind(this)

        this.state = {
            hotelCode: hotelCode,
            hotelInfo: hotelInfo,
            isHotelDomestic: isDomestic,
            isLoading: true,
            loadingMessage: FormConst.MODAL_READ_ACTION_TEXT,
            showDeleteModal: false,
            showErrorModal: false,
            deleteIndex: -1,
            maximumRoomCount: hotelInfo.guestRooms,
            hotelInfoCompletedHistory: hotelInfoCompletedHistory
        }
    }

    async componentDidMount() {
        if (isCompletedHotelInfoHistory(this.state.hotelInfoCompletedHistory)) {
            const hotelCode = this.state.hotelInfoCompletedHistory.newEntity?.hotelRoomTypes?.hotelCode;
            const roomTypes = this.state.hotelInfoCompletedHistory.newEntity?.hotelRoomTypes?.roomTypes;

            const findHotelCodeInExceptionList = (hotelCodeEnv) => hotelCodeEnv === hotelCode;
            const isHotelCodeInExceptionList = EnvVarsConst.ROOM_TYPE_EXCEPTIONS?.split(",").findIndex(findHotelCodeInExceptionList)
            const roomTypesLimit = (isHotelCodeInExceptionList !== undefined && isHotelCodeInExceptionList > -1) ? 50 : 24;

            let definedRoomCount = 0
            let existingRoomTypes = 0
            if (isArrayNotEmpty(roomTypes)) {
                roomTypes.forEach(roomType => {
                    definedRoomCount += roomType.roomCount
                })
                existingRoomTypes = roomTypes.length
            }
            this.setState({
                              roomTypes: roomTypes,
                              definedRoomCount: definedRoomCount,
                              existingRoomTypes: existingRoomTypes,
                              roomTypesLimit: roomTypesLimit,
                              isLoading: false
                          })

        } else {
            await RoomTypesService.getRoomTypes({ hotelCode: this.state.hotelCode })
                .then(response => {
                    const roomTypes = response.roomTypes
                    const roomTypesLimit = response.roomTypesLimit
                    let definedRoomCount = 0
                    let existingRoomTypes = 0
                    if (isArrayNotEmpty(roomTypes)) {
                        roomTypes.forEach(roomType => {
                            definedRoomCount += roomType.roomCount
                        })
                        existingRoomTypes = roomTypes.length
                    }
                    this.setState({
                                      roomTypes: roomTypes,
                                      definedRoomCount: definedRoomCount,
                                      existingRoomTypes: existingRoomTypes,
                                      roomTypesLimit: roomTypesLimit,
                                      isLoading: false
                                  })
                }).catch(error => {
                    this.setState({
                                      isLoading: false,
                                      error: 'There was an error while reading Room Types data',
                                      showErrorModal: true
                                  })
                })
        }

    }

    onEdit = (index) => {
        const roomTypeToEdit = this.state.roomTypes[index]
        this.props.history.push(
            {
                pathname: RouteConst.ROUTE_ROOM_TYPE_PAGE,
                state: {
                    roomTypes: this.state.roomTypes,
                    roomType: roomTypeToEdit,
                    isEdit: true,
                    editIndex: index,
                    maximumAllowedRoomCount: this.state.maximumRoomCount - this.state.definedRoomCount + roomTypeToEdit.roomCount
                }
            })
    }

    addRoomType = () => {
        this.props.history.push(
            {
                pathname: RouteConst.ROUTE_ROOM_TYPE_PAGE,
                state: {
                    roomTypes: this.state.roomTypes,
                    maximumAllowedRoomCount: this.state.maximumRoomCount - this.state.definedRoomCount
                }
            })
    }

    addRoomTypeBuckets = () => {
        this.props.history.push(
            {
                pathname: RouteConst.ROUTE_ROOM_TYPE_BUCKETS_PAGE,
                state: {
                    roomTypes: this.state.roomTypes
                }
            })
    }

    deleteRoomType = () => {
        let roomTypes = [...this.state.roomTypes]
        const deletedRoomType = roomTypes.splice(this.state.deleteIndex, 1)
        this.props.onPut({ hotelCode: this.state.hotelCode, roomTypes: roomTypes })
        this.setState({ pendingRoomTypes: roomTypes, pendingDefinedRoomCount: this.state.definedRoomCount - deletedRoomType[0].roomCount, isLoading: true, loadingMessage: FormConst.MODAL_UPDATE_ACTION_TEXT, showDeleteModal: false })
    }

    handleDelete = (index) => {
        this.setState({
            showDeleteModal: true,
            deleteIndex: index
        })
    }


    componentDidUpdate(prevProps) {
        if (prevProps.count !== this.props.count) {
            if (this.props.errorMessage) {
                this.setState({
                    isLoading: false,
                    pendingRoomTypes: undefined,
                    showErrorModal: true,
                    errorMessage: this.props.errorDescription
                })
            } else {
                this.setState({
                    isLoading: false,
                    roomTypes: this.state.pendingRoomTypes,
                    definedRoomCount: this.state.pendingDefinedRoomCount,
                    pendingRoomTypes: undefined,
                    pendingDefinedRoomCount: undefined
                })
            }
        }
    }

    getRoomCategoryFromValue = (roomCategoryValue) => {
        let roomCategory = FormConst.ROOM_CATEGORY_OPTIONS.find(category => category.value === roomCategoryValue)
        return roomCategory ? roomCategory.label : ''
    }

    render() {

        return (
            <div className='room-types-page'>
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><NavLink to='/'>Home</NavLink></li>
                        <li className="breadcrumb-item active" aria-current="page">Room Types</li>
                    </ol>
                </nav>
                {/* Helper text */}
                <p className='helper-text'>This page is about room types information.</p>
                {/* Show room count details */}
                <Card
                    id='room-types-count-info-card'
                    className='room-types-count-info-card'
                    header='Room Count Information'
                    text={(
                        <Row className='d-flex align-items-center'>
                            <Col xs={12} sm={12} md={12} lg={6} xl={6}>
                                <dt>Maximum Room Count</dt>
                                <dd>{this.state.maximumRoomCount}</dd>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={6} xl={6}>
                                <dt>Defined Room Count</dt>
                                <dd>{this.state.definedRoomCount}</dd>
                            </Col>
                        </Row>
                    )}
                    isFill />

                {/* Show room type details */}
                <table className='table table-striped room-types-table'>
                    <caption>Room Types Details</caption>
                    <thead>
                        <tr>
                            <th>Code</th>
                            <th>Master Room Type Code</th>
                            <th className='d-none d-lg-table-cell'>Description</th>
                            <th className='d-none d-lg-table-cell'>Max Occupancy</th>
                            <th className='d-none d-lg-table-cell'>Room Count</th>
                            {
                                EnvVarsConst.ROOM_CATEGORY_ENABLED && <th className='d-none d-lg-table-cell'>Room Category</th>
                            }

                            <th>Edit</th>
                            <th>Delete</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            isArrayNotEmpty(this.state.roomTypes)
                                ? this.state.roomTypes.map((roomType, index) => {
                                    return <tr key={index}>
                                        <td>{roomType.hotelRoomTypeCode}</td>
                                        <td>{roomType.masterRoomTypeCode}</td>
                                        <td className='d-none d-lg-table-cell'>{roomType.description}</td>
                                        <td className='d-none d-lg-table-cell'>{roomType.maxOccupancy}</td>
                                        <td className='d-none d-lg-table-cell'>{roomType.roomCount}</td>
                                        {
                                            EnvVarsConst.ROOM_CATEGORY_ENABLED && <td className='d-none d-lg-table-cell'>{this.getRoomCategoryFromValue(roomType.roomCategory)}</td>
                                        }

                                        <td>
                                            <Button name={<FaEdit />} role='link' className='icon-link' onClick={() => this.onEdit(index)} overridedisabledflag='true' />
                                        </td>
                                        <td>
                                            <Button name={<FaTrashAlt />} role='link' className='icon-link' onClick={() => this.handleDelete(index)} />
                                        </td>
                                    </tr>
                                })
                                : <tr>
                                    <td colSpan="8">No room types defined.</td>
                                </tr>
                        }
                    </tbody>

                </table>



                <div className={"container"}>
                    <Row>
                        <div className="col">
                            {
                                ((this.state.definedRoomCount < this.state.maximumRoomCount) && (this.state.existingRoomTypes < this.state.roomTypesLimit))
                                && (
                                    <Button
                                        id="add-room-type-button"
                                        name='Add Room Type'
                                        type="button"
                                        className='.add-room-type-button'
                                        onClick={this.addRoomType} />
                                )
                            }
                        </div>
                        <div className="col-6">
                        </div>
                        <div className="col">
                            {
                                /** Show only for Radisson Brands **/
                                isRadissonProperty(this.state.hotelInfo.brandCode) && isManageRoomTypeBucketsEnabled(this.state.hotelInfo.brandCode, this.state.isHotelDomestic)
                                && (
                                    <Button
                                        id="add-room-type-buckets-button"
                                        name='Manage Room Type Buckets'
                                        type="button"
                                        className='.add-room-type-button'
                                        overridedisabledflag='true'
                                        onClick={this.addRoomTypeBuckets} />
                                )

                            }
                        </div>
                    </Row>
                    <Row>
                        {
                            this.state.existingRoomTypes == this.state.roomTypesLimit
                            &&(
                                <div className="col">
                                    <p className="invalid">The Room Types limit of {this.state.roomTypesLimit} has been reached.</p>
                                </div>
                            )

                        }

                    </Row>
                </div>

                <FormFooter
                    form={SideNavEntryMapping.ROOM_TYPES}
                    submitName='Next Section'
                    onSubmit={() => { this.props.history.push(RouteConst.ROUTE_MEETING_ROOMS_PAGE) }}
                    noSubmit
                    noReset />
                <FormModal
                    id='room-types-page-loading-modal'
                    title={FormConst.MODAL_UPDATE_ACTION_TITLE}
                    hotelInfo={this.state.hotelInfo}
                    body={<h5>{this.state.loadingMessage}</h5>}
                    show={this.state.isLoading}
                    isLoadingIndicator />
                <FormModal
                    id='room-types-page-delete-modal'
                    hotelInfo={this.state.hotelInfo}
                    title='Delete Room Type'
                    body={<h5>{FormConst.MODAL_DELETE_ACTION_TEXT}</h5>}
                    proceed={this.deleteRoomType}
                    cancel={() => { this.setState({ showDeleteModal: false, deleteIndex: -1 }) }}
                    show={this.state.showDeleteModal} />
                <FormModal
                    id='room-types-page-error-modal'
                    hotelInfo={this.state.hotelInfo}
                    title={FormConst.MODAL_UPDATE_ACTION_ERROR_TITLE}
                    body={<h5>{this.state.errorMessage}</h5>}
                    isError
                    cancel={() => { this.setState({ showErrorModal: false }) }}
                    show={this.state.showErrorModal} />
            </div>
        )
    }
}

// Sample redux dispatch
const mapStateToProps = state => {
    return {
        roomTypesResponse: state.reducer.response,
        errorMessage: state.reducer.errorMessage,
        errorDescription: state.reducer.errorDescription,
        count: state.reducer.count
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onGet: (hotelCode) => dispatch(asyncMethod(FormConst.FORM_ROOM_TYPES_NAME, actionTypes.ASYNC_ACTIONS.GET, { hotelCode: hotelCode })),
        onPut: (data) => dispatch(asyncMethod(FormConst.FORM_ROOM_TYPES_NAME, actionTypes.ASYNC_ACTIONS.PUT, data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withFormLayout(RoomTypes, SideNavEntryMapping.ROOM_TYPES))
